import React, { useState, useEffect } from 'react';
import { FiEdit2, FiTrash2, FiPlus, FiSave, FiX, FiAward, FiCheck } from 'react-icons/fi';
import ImageUploadField from './ImageUploadField';
import './AdminManage.css';

const STORAGE_KEY = 'iamar_research_committee_data';

const DEFAULT_RESEARCHERS = [
  { id: 1, name: "Prof. Ahmed Alami", title: "Directeur de Recherche", countryCode: "ma", country: "Maroc", company: "Université Mohammed V", company_logo: "", image: "" },
  { id: 2, name: "Dr. Marie Lefebvre", title: "Chercheuse Senior", countryCode: "fr", country: "France", company: "CNRS", company_logo: "", image: "" },
  { id: 3, name: "Prof. John Smith", title: "Expert en Cyber-sécurité", countryCode: "us", country: "USA", company: "MIT", company_logo: "", image: "" },
  { id: 4, name: "Dr. Fatima Zahra", title: "Spécialiste IA", countryCode: "ae", country: "UAE", company: "Khalifa University", company_logo: "", image: "" }
];

export default function AdminResearchCommittee() {
  const [researchers, setResearchers] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    country: 'Maroc',
    countryCode: 'ma',
    company: '',
    company_logo: '',
    image: ''
  });

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        setResearchers(JSON.parse(saved));
      } else {
        setResearchers(DEFAULT_RESEARCHERS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_RESEARCHERS));
      }
    } catch (e) {
      console.error(e);
      setResearchers(DEFAULT_RESEARCHERS);
    }
  }, []);

  const saveList = (updated) => {
    setResearchers(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    setSaveSuccess(true);
    setTimeout(() => setSaveSuccess(false), 2500);
  };

  const handleEdit = (item) => {
    setFormData(item);
    setEditingId(item.id);
    setIsFormOpen(true);
  };

  const handleDelete = (id) => {
    if (window.confirm('Voulez-vous vraiment retirer ce membre du comité ?')) {
      const updated = researchers.filter(r => r.id !== id);
      saveList(updated);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name) return;

    let updated;
    if (editingId) {
      updated = researchers.map(r => r.id === editingId ? { ...formData, id: editingId } : r);
    } else {
      const newItem = { ...formData, id: Date.now() };
      updated = [newItem, ...researchers];
    }
    saveList(updated);
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      name: '',
      title: '',
      country: 'Maroc',
      countryCode: 'ma',
      company: '',
      company_logo: '',
      image: ''
    });
    setEditingId(null);
    setIsFormOpen(false);
  };

  return (
    <div className="admin-manage-card" style={{ background: '#ffffff', borderRadius: 8, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: 16, marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '1.4rem', color: '#1b1e4f', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 10 }}>
            <FiAward /> Gestion du Comité Scientifique
          </h2>
          <p style={{ margin: '4px 0 0 0', color: '#64748b', fontSize: '0.88rem' }}>
            Gérez les chercheurs et universitaires membres du comité scientifique (/research) avec upload de photos
          </p>
        </div>

        <button
          onClick={() => {
            resetForm();
            setIsFormOpen(true);
          }}
          style={{
            background: '#1b1e4f',
            color: 'white',
            border: 'none',
            padding: '9px 18px',
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}
        >
          <FiPlus size={16} /> Ajouter un membre
        </button>
      </div>

      {saveSuccess && (
        <div style={{ background: '#d1fae5', border: '1px solid #10b981', color: '#065f46', padding: '10px 16px', borderRadius: 6, marginBottom: 16, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
          <FiCheck size={16} /> Modifications enregistrées et appliquées à la page Comité Scientifique !
        </div>
      )}

      {/* Form */}
      {isFormOpen && (
        <div style={{ background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: 8, padding: 20, marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b' }}>
              {editingId ? "Modifier le membre" : "Ajouter un chercheur au comité"}
            </h3>
            <button onClick={resetForm} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: '#64748b' }}>
              <FiX size={20} />
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
              <ImageUploadField
                label="Photo du chercheur (Upload image)"
                value={formData.image}
                onChange={(url) => setFormData(prev => ({ ...prev, image: url }))}
                helpText="Importez un portrait du membre du comité"
              />

              <ImageUploadField
                label="Logo de l'Université / Laboratoire (Upload image)"
                value={formData.company_logo}
                onChange={(url) => setFormData(prev => ({ ...prev, company_logo: url }))}
                helpText="Importez le logo de l'université ou laboratoire de rattachement"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Nom complet *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Prof. Ahmed Alami"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Titre / Fonction *</label>
                <input
                  type="text"
                  required
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Directeur de Recherche"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Université / Organisation</label>
                <input
                  type="text"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Université Ibn Zohr / CNRS"
                />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Pays</label>
                <input
                  type="text"
                  value={formData.country}
                  onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: Maroc"
                />
              </div>

              <div>
                <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Code Pays (drapeau, ex: ma, fr, us)</label>
                <input
                  type="text"
                  value={formData.countryCode}
                  onChange={(e) => setFormData({ ...formData, countryCode: e.target.value.toLowerCase() })}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                  placeholder="Ex: ma"
                  maxLength={2}
                />
              </div>
            </div>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
              <button
                type="button"
                onClick={resetForm}
                style={{ background: '#e2e8f0', color: '#475569', border: 'none', padding: '9px 18px', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
              >
                Annuler
              </button>
              <button
                type="submit"
                style={{ background: '#1b1e4f', color: 'white', border: 'none', padding: '9px 22px', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
              >
                <FiSave size={15} /> {editingId ? 'Enregistrer les modifications' : 'Ajouter au comité'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 18 }}>
        {researchers.map(r => (
          <div
            key={r.id}
            style={{
              border: '1px solid #e2e8f0',
              borderRadius: 8,
              padding: 16,
              background: '#ffffff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.03)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div>
              <div style={{ display: 'flex', gap: 14, alignItems: 'center', marginBottom: 12 }}>
                <div style={{ width: 64, height: 64, borderRadius: '50%', overflow: 'hidden', background: '#f1f5f9', border: '2px solid #cbd5e1', flexShrink: 0 }}>
                  {r.image ? (
                    <img src={r.image} alt={r.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
                      <FiAward size={24} />
                    </div>
                  )}
                </div>

                <div style={{ minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <h4 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1e293b' }}>{r.name}</h4>
                    {r.countryCode && (
                      <img src={`https://flagcdn.com/24x18/${r.countryCode}.png`} alt={r.country} style={{ width: 16, height: 12 }} />
                    )}
                  </div>
                  <p style={{ margin: '3px 0 0 0', fontSize: 12, color: '#059669', fontWeight: 600 }}>{r.title}</p>
                  <p style={{ margin: '2px 0 0 0', fontSize: 11, color: '#64748b' }}>{r.company}</p>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, borderTop: '1px solid #f1f5f9', paddingTop: 10 }}>
              <button
                onClick={() => handleEdit(r)}
                style={{ background: '#f1f5f9', color: '#2563eb', border: 'none', padding: '6px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
              >
                <FiEdit2 size={13} /> Modifier
              </button>
              <button
                onClick={() => handleDelete(r.id)}
                style={{ background: '#fee2e2', color: '#dc2626', border: 'none', padding: '6px 12px', borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
              >
                <FiTrash2 size={13} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
